<template>
  <div class="page page-insurance-detail" v-if="article">
    <section class="section">
      <div class="section-inner">
        <article class="detail-article">
          <header class="detail-header">
            <h1 class="detail-title">{{ article.title }}</h1>
            <div class="detail-meta">
              <span>作者：{{ article.author }}</span>
              <span>· 发布时间：{{ article.date }}</span>
              <span>· 阅读量：{{ currentReadCount }}</span>
            </div>
          </header>
          <div class="detail-content" v-html="article.content"></div>
        </article>
        <footer class="detail-footer">
          <div
            v-if="prevArticle"
            class="nav-link"
            @click="goDetail(prevArticle.id)"
          >
            上一篇：{{ prevArticle.title }}
          </div>
          <div
            v-if="nextArticle"
            class="nav-link"
            @click="goDetail(nextArticle.id)"
          >
            下一篇：{{ nextArticle.title }}
          </div>
        </footer>
      </div>
    </section>
  </div>
  <div v-else class="page page-insurance-detail">
    <section class="section">
      <div class="section-inner">
        <p>未找到对应的文章。</p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InsuranceDetail',
  data() {
    return {
      article: null
    }
  },
  computed: {
    ...mapGetters(['getInsuranceReadCount', 'getInsuranceList', 'getInsuranceById']),
    currentReadCount() {
      if (!this.article) return 0
      return this.getInsuranceReadCount(this.article.id)
    },
    currentIndex() {
      if (!this.article) return -1
      return this.getInsuranceList.findIndex(item => item.id === this.article.id)
    },
    prevArticle() {
      if (this.currentIndex > 0) return this.getInsuranceList[this.currentIndex - 1]
      return null
    },
    nextArticle() {
      if (this.currentIndex >= 0 && this.currentIndex < this.getInsuranceList.length - 1) {
        return this.getInsuranceList[this.currentIndex + 1]
      }
      return null
    }
  },
  watch: {
    '$route.params.id': { immediate: true, handler() { this.initArticle() } }
  },
  methods: {
    async initArticle() {
      const id = Number(this.$route.params.id)
      let found = this.getInsuranceById(id)
      if (!found && !this.getInsuranceList.length) {
        await this.$store.dispatch('fetchInsurance')
        found = this.getInsuranceById(id)
      }
      this.article = found || null
      if (this.article) {
        this.$store.dispatch('incrementInsuranceReadCount', this.article.id)
      }
    },
    goDetail(id) {
      this.$router.push(`/insurance/${id}`)
    }
  }
}
</script>

<style scoped>
.page {
  background: #f5f7fa;
}

.detail-article {
  background: #ffffff;
  border-radius: 18px;
  padding: 22px 24px 28px;
  box-shadow: 0 18px 46px rgba(15, 23, 42, 0.16);
}

.detail-header {
  margin-bottom: 18px;
}

.detail-title {
  font-size: 26px;
  color: #102a43;
  margin-bottom: 10px;
}

.detail-meta {
  font-size: 13px;
  color: #9fb3c8;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}

.detail-content {
  margin-top: 8px;
  font-size: 15px;
  color: #374151;
  line-height: 1.9;
  word-break: break-word;
}

.detail-content >>> p + p {
  margin-top: 12px;
}

.detail-content >>> img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 16px auto;
  border-radius: 8px;
}

.detail-content >>> h1,
.detail-content >>> h2,
.detail-content >>> h3 {
  color: #102a43;
  margin: 20px 0 10px;
  line-height: 1.4;
  font-weight: 600;
}

.detail-content >>> h1 { font-size: 22px; }
.detail-content >>> h2 { font-size: 19px; }
.detail-content >>> h3 { font-size: 17px; }

.detail-content >>> ul,
.detail-content >>> ol {
  margin: 10px 0 10px 1.4em;
  padding: 0;
}

.detail-content >>> li + li {
  margin-top: 6px;
}

.detail-content >>> a {
  color: #2563eb;
  text-decoration: underline;
}

.detail-content >>> blockquote {
  margin: 14px 0;
  padding: 10px 14px;
  border-left: 3px solid #93c5fd;
  background: #f8fafc;
  color: #475569;
}

.detail-footer {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  color: #2563eb;
}

.nav-link {
  cursor: pointer;
}

.nav-link:hover {
  text-decoration: underline;
}

@media (max-width: 640px) {
  .detail-title {
    font-size: 20px;
  }

  .detail-article {
    padding-inline: 16px;
  }
}
</style>

